<template>
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9999 5.99994H3.4099L6.7099 2.70994C6.8982 2.52164 7.00399 2.26624 7.00399 1.99994C7.00399 1.73364 6.8982 1.47825 6.7099 1.28994C6.52159 1.10164 6.2662 0.99585 5.9999 0.99585C5.73359 0.99585 5.4782 1.10164 5.2899 1.28994L0.289896 6.28994C0.198856 6.38505 0.127491 6.49719 0.0798963 6.61994C-0.0201217 6.8634 -0.0201217 7.13648 0.0798963 7.37994C0.127491 7.50269 0.198856 7.61484 0.289896 7.70994L5.2899 12.7099C5.38286 12.8037 5.49346 12.8781 5.61532 12.9288C5.73718 12.9796 5.86788 13.0057 5.9999 13.0057C6.13191 13.0057 6.26261 12.9796 6.38447 12.9288C6.50633 12.8781 6.61693 12.8037 6.7099 12.7099C6.80363 12.617 6.87802 12.5064 6.92879 12.3845C6.97956 12.2627 7.00569 12.132 7.00569 11.9999C7.00569 11.8679 6.97956 11.7372 6.92879 11.6154C6.87802 11.4935 6.80363 11.3829 6.7099 11.2899L3.4099 7.99994H10.9999C11.2651 7.99994 11.5195 7.89458 11.707 7.70705C11.8945 7.51951 11.9999 7.26516 11.9999 6.99994C11.9999 6.73472 11.8945 6.48037 11.707 6.29283C11.5195 6.1053 11.2651 5.99994 10.9999 5.99994Z"
      fill="#110F13"
    />
  </svg>
</template>
